import React from 'react'
 

export const HotelHero = () => {
  return (
    <div>
        <div className='bg-[#DEEFFF] h-full flex items-center justify-between w-full flex-col lg:flex-row'>
        <div className='p-8 pt-28 md:p-24 md:pt-36 lg:p-36'>
            <h1 className='text-3xl md:text-3xl  font-bold uppercase  text-[#272727]'>
                 Discover your ideal <span class='text-[#41A4FF]'>Hotel</span> and <span class='text-[#41A4FF]'>book</span> your next stay today!
            </h1>
        </div>
    </div>
    </div>
  )
}
